import SpriteSvg from 'onspace/assets/elements/svg'
import { preloadSprites } from 'onspace/assets/elements/svg'

preloadSprites()

export default SpriteSvg
